// extracted by mini-css-extract-plugin
export default {"band":"FootBand_band__RxHzC"};